"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../../Constant");

var _Constant2 = require("../../Constant");

var _ExpandableSidebarListItem = _interopRequireDefault(require("./ExpandableSidebarListItem"));

var _SidebarLinkItem = _interopRequireDefault(require("./SidebarLinkItem"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    min-height: 100vh;\n    height: 100%;\n    /* border to improve experience for Windows high contrast users */\n    border-left: 1px solid transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.aside(_templateObject(), _Constant2.Color.WHITE, _Constant.Width.MD);

var MarketingSidebar = function MarketingSidebar(_ref) {
  var listItems = _ref.listItems;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-testid": "test-marketing-sidebar"
  }, listItems.map(function (item) {
    var listItem = item.expandable ? /*#__PURE__*/_react.default.createElement(_ExpandableSidebarListItem.default, {
      marketingIcon: item.icon,
      label: item.sectionHeader
    }, /*#__PURE__*/_react.default.createElement(item.panel, null)) : /*#__PURE__*/_react.default.createElement(_SidebarLinkItem.default, {
      isRouterLink: item.isRouterLink,
      label: item.sectionHeader,
      marketingIcon: item.icon,
      onClick: item.onClick,
      to: item.to
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: item.sectionHeader
    }, /*#__PURE__*/_react.default.createElement("section", null, listItem));
  }));
};

MarketingSidebar.propTypes = {
  /** Sidebar main list items */
  listItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** label of the section */
    sectionHeader: _propTypes.default.string,

    /** the icon of the left that visually represents the list item */
    icon: _propTypes.default.node,

    /** Renders a React Router Link so page will not refresh */
    isRouterLink: _propTypes.default.bool,

    /** a boolean describing whether a list item is expandable */
    expandable: _propTypes.default.bool,

    /** inner content for expandable sections */
    panel: _propTypes.default.func,

    /** if the list item is not expandable, provide an onClick handler */
    onClick: _propTypes.default.func,

    /** The URL assigned to the `to` attribute on a React Router Link or to the `href` on a regular link.
     * When using the default HTML anchor element, to should be passed a string.
     * When using isRouterLink, to can be a string, an object, or a function that returns a string or object.
     */
    to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
  }))
};
MarketingSidebar.defaultProps = {
  listItems: []
};
var _default = MarketingSidebar;
exports.default = _default;